import { render } from "./Storage.html?vue&type=template&id=c351a650&ts=true"
import script from "./Storage.ts?vue&type=script&lang=ts"
export * from "./Storage.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__